import api from "../../api";
import type { NotificationsApiResponse } from "../../../@types/portalAluno";
import { mapNotificationsResponse } from "../../../utils/portalAluno/mappers/notificationsMapper";

export const getNotifications = async () => {
  const response = await api.get<NotificationsApiResponse>(
    "mobile/notificacoes"
  );

  return mapNotificationsResponse(response.data);
};
